export default __webpack_public_path__ + "static/media/tape-instructions.8429220d.svg";